// TODO: Should it be here? Or should it be in the user services?
// Creates a new user with email and password.
export const signUp = async ($fire: any, { email, password }: any) => {
  return await $fire.auth.createUserWithEmailAndPassword(email, password)
}

// TODO: Should it be here? Or should it be in the user services?
// Signs in a user with a custom authentication token.
export const signInCustomToken = async ($fire: any, { credential }: any) => {
  return await $fire.auth.signInWithCustomToken(credential)
}

// TODO: Should it be here? Or should it be in the user services?
// Updates the profile of the currently authenticated user.
export const updateUserAuth = async ($fire: any, user: any) => {
  const currentUser = $fire.auth.currentUser
  return await currentUser.updateProfile(user)
}

// TODO: Should it be here? Or should it be in the user services?
// Re-authenticates the current user with new credentials.
export const reauthenticate = async ($fire: any, credential: any) => {
  const currentUser = $fire.auth.currentUser
  return await currentUser.reauthenticateWithCredential(credential)
}

// TODO: Should it be here? Or should it be in the user services?
// Updates the current user's password.
export const updatePasswordAuth = async (
  $fire: any,
  confirmNewPassword: string
) => {
  const currentUser = $fire.auth.currentUser
  return await currentUser.updatePassword(confirmNewPassword)
}

// TODO: Should it be here? Or should it be in the user services?
// Updates the current user's email.
export const updateEmailAuth = async ($fire: any, newEmail: string) => {
  const currentUser = $fire.auth.currentUser
  return await currentUser.updateEmail(newEmail)
}

// TODO: Should it be here? Or should it be in the user services?
// Retrieves email and password credentials for authentication.
export const getCredentialToAuth = async (
  $fireModule: any,
  body: { email: any; currentPassword: any }
) => {
  return await $fireModule.auth.EmailAuthProvider.credential(
    body.email,
    body.currentPassword
  )
}

// TODO: Should it be here? Or should it be in the user services?
// Logs in a user with email and password.
export const logIn = async ($fire: any, { email, password }: any) => {
  return await $fire.auth.signInWithEmailAndPassword(email, password)
}

// TODO: Should it be here? Or should it be in the user services?
// Logs out the current user.
export const logOut = async ($fire: any) => {
  return await $fire.auth.signOut()
}

// Fetches dependencies from the Firestore catalog.
export const getDependencies = async ($fire: any) => {
  const dependencies: any[] = []
  await $fire.firestore
    .collection('catalogs')
    .where('slug', '==', 'dependencias')
    .get()
    .then(async (querySnapshot: any) => {
      if (querySnapshot.docs.length > 0) {
        const catalogId = querySnapshot.docs[0].id

        await $fire.firestore
          .collection(`catalogs/${catalogId}/terms`)
          .get()
          .then((queryTerms: any) => {
            if (queryTerms.docs.length > 0) {
              queryTerms.docs.forEach((doc: any) => {
                dependencies.push({ ...doc.data() })
              })
            }
          })
      }
    })
  return dependencies
}

// Fetches a dependency by its ID.
export const getDependencyById = async ($fire: any, id: string) => {
  return await $fire.firestore
    .collectionGroup('terms')
    .where('id', '==', id)
    .get()
}

// Fetches subdependencies for a given dependency.
export const getSubdependencies = async ($fire: any, dependencyId: any) => {
  const subdependencies: any[] = []
  let catalogId = ''
  await $fire.firestore
    .collection('catalogs')
    .where('slug', '==', 'dependencias')
    .get()
    .then((querySnapshot: any) => {
      if (querySnapshot.docs.length > 0) {
        catalogId = querySnapshot.docs[0].id
      }
    })

  if (catalogId) {
    await $fire.firestore
      .collection(`catalogs/${catalogId}/terms/${dependencyId}/terms`)
      .get()
      .then((queryTerms: any) => {
        if (queryTerms.docs.length > 0) {
          queryTerms.docs.forEach((doc: any) => {
            subdependencies.push({ ...doc.data() })
          })
        }
      })
  }
  return subdependencies
}

// Uploads a file to Firebase storage under the specified folder.
export const saveFile = async ($fire: any, file: any, folder: string) => {
  const fileRef = $fire.storage().ref().child(`${folder}/${file.name}`)
  await fileRef.put(file)
}
